import { AfterViewInit, Directive, ElementRef, HostListener, OnInit } from "@angular/core";

@Directive({
	selector: '[focus]',
	standalone: true
})
export class FocusDirective implements AfterViewInit {

	constructor(private elm: ElementRef) {
	}

	ngAfterViewInit(): void {

		this.elm.nativeElement.querySelector('input').focus();
	}
}